module.exports = __webpack_public_path__ + "img/collection-memoireRingsBudgetHigh@2x.bb1fc20.jpg";